import request from '../utils/request';

/**
 * 登录
 */
export const login = (data) => {
  return request.post(`/app-api/member/auth/login`, { data });
};

/**
 * 设置预约时间
 */
export const setAppointementTime = (data) => {
  return request.post(`/app-api/therapy/member/user/set-appointment-time`, { data });
};

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return request.get(`/app-api/member/user/get`);
};

/**
 * 修改用户信息
 */
export const editUserInfo = (data) => {
  return request.put(`/app-api/member/user/update`, { data });
};

/**
 * 获取当前治疗方案的疗程id
 */
export const getCurrentId = (code) => {
  return request.post(`/app-api/api/treatment/${code}/current`);
};

/**
 * 获取危机干预热线
 */
export const getHotline = () => {
  return request.get(`/app-api/member/user/get-hotline`);
};

/**
 * 获取code
 */
export const getCode = () => {
  return request.get(`/app-api/api/treatment/getFlow`);
} 

/**
 * 退出登陆
 */
export const loginOut = () => {
  return request.post(`/app-api/member/auth/logout`);
} 